/**
 * Constants for order management hooks
 */

/**
 * Maps field IDs to their translation keys used in FieldButton components
 * These are the actual labels displayed in the UI
 */
export const FIELD_LABELS: Record<string, {key: string; fallback: string}> = {
  // Changeable fields
  material: {key: 'orderIntake.rmc.orderManagement.mixType', fallback: 'Mix type'},
  usage: {key: 'orderIntake.rmc.orderManagement.editSteps.labels.usage', fallback: 'Usage'},
  quantity: {key: 'orderIntake.rmc.orderManagement.editSteps.labels.quantity', fallback: 'Quantity'},
  intervals: {key: 'orderIntake.rmc.orderManagement.editSteps.labels.intervals', fallback: 'Intervals'},
  date: {key: 'orderIntake.rmc.orderManagement.editSteps.labels.date', fallback: 'Date'},
  time: {key: 'orderIntake.rmc.orderManagement.editSteps.labels.time', fallback: 'Start time'},
  materialTesting: {
    key: 'orderIntake.rmc.orderManagement.editSteps.labels.materialTesting',
    fallback: 'Material testing'
  },
  retarder: {key: 'orderIntake.rmc.orderManagement.editSteps.labels.retarder', fallback: 'Retarder'},
  siteContact: {key: 'orderIntake.rmc.orderManagement.siteContact', fallback: 'Site contact'},
  poNumber: {key: 'orderIntake.rmc.orderManagement.editSteps.labels.poNumber', fallback: 'PO number'},
  driverInstructions: {
    key: 'orderIntake.rmc.orderManagement.editSteps.labels.driverInstructions',
    fallback: 'Driver instructions'
  },
  additionalNotes: {
    key: 'orderIntake.rmc.orderManagement.editSteps.labels.additionalNotes',
    fallback: 'Additional notes'
  },
  // Non-changeable fields
  address: {key: 'orderIntake.rmc.orderManagement.address', fallback: 'Address'},
  orderPlacer: {key: 'orderIntake.rmc.orderManagement.orderPlacer', fallback: 'Order placer'},
  status: {key: 'orderManagement.orderStatus', fallback: 'Status'}
}
